import { render, staticRenderFns } from "./ContactAlert.vue?vue&type=template&id=47796b90&"
import script from "./ContactAlert.vue?vue&type=script&lang=js&"
export * from "./ContactAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports